/**
 * TaskQuickCreateButton
 * Botão "Nova Tarefa" com o contexto da tela (processo, cliente, atendimento):
 * abre a gaveta única de tarefa já preenchida. O formulário próprio que
 * existia aqui foi substituído pela gaveta (fase 4).
 */
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTaskDrawer, type TaskPrefill } from '@/contexts/TaskDrawerContext'

export interface TaskContext {
  clientId?: string
  clientName?: string
  caseId?: string
  caseTitle?: string
  caseNumber?: string
  interactionId?: string
  interactionSubject?: string
  originType?: 'from_interaction' | 'from_case' | 'manual'
}

export interface TaskQuickCreateButtonProps {
  context: TaskContext
  onTaskCreated?: () => void
  className?: string
  buttonLabel?: string
}

export function prefillFromContext(context: TaskContext): TaskPrefill {
  // Pelo nome do caso: o número pode ser o interno do escritório, que não aparece na tela
  const label = context.caseTitle
    ? `${context.caseTitle}${context.clientName ? ` · ${context.clientName}` : ''}`
    : context.caseNumber
    ? `Processo ${context.caseNumber}${context.clientName ? ` · ${context.clientName}` : ''}`
    : context.interactionSubject
      ? `Atendimento: ${context.interactionSubject}`
      : context.clientName
        ? `Cliente ${context.clientName}`
        : undefined
  return {
    client_id: context.clientId || undefined,
    client_name: context.clientName,
    case_id: context.caseId,
    case_title: context.caseTitle,
    case_number: context.caseNumber,
    interaction_id: context.interactionId,
    origin_type: context.originType ?? 'manual',
    origemLabel: label,
  }
}

export function TaskQuickCreateButton({ context, onTaskCreated, className = '', buttonLabel = 'Nova Tarefa' }: TaskQuickCreateButtonProps) {
  const drawer = useTaskDrawer()
  return (
    <Button type="button" size="sm" className={className} onClick={() => drawer.newTask(prefillFromContext(context), onTaskCreated)}>
      <Plus className="size-4" /> {buttonLabel}
    </Button>
  )
}
